<template lang='pug' src='./AddQuotes.pug'></template>

<script>
  import Vue from 'vue'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'AddQuotes',
    data: function () {
      return {
        form: {
          quote: undefined,
          author: Vue.config.kQuotes.FORM.EXTERNAL_AUTHOR_LIST.id,
          externalAuthor: undefined,
          explanation: undefined
        },
        error: {
          textError: undefined,
          authorError: undefined,
          externalError: undefined
        },
        button: Vue.config.kQuotes.FORM.ADD_BUTTON,
        externalDisabled: false
      }
    },
    watch: {
      'form.author': {
        handler: function (currentAuthor, oldAuthor) {
          if (!oldAuthor) {
            return
          }

          const NEW_AUTHOR = currentAuthor !== oldAuthor
          const IS_EXTERNAL = currentAuthor === this.external.id

          this.externalDisabled = !(NEW_AUTHOR && IS_EXTERNAL)
          if (this.externalDisabled) {
            this.form.externalAuthor = undefined
          }
        },
        immediate: true,
        deep: true
      }
    },
    mounted () {
      this.$refs.textQuote.focus()
      document.body.classList.add('no-scroll')
    },
    destroyed () {
      document.body.classList.remove('no-scroll')
    },
    created () {
      if (this.getActiveQuote.quote) {
        this.form.quote = this.getActiveQuote.quote
        this.button = Vue.config.kQuotes.FORM.EDIT_QUOTE
      }
      if (this.getActiveQuote.author && this.getActiveQuote.author.id) {
        this.form.author = this.getActiveQuote.author.id
      }
      if (this.getActiveQuote.externalAuthor) {
        this.form.externalAuthor = this.getActiveQuote.externalAuthor
        this.form.author = this.external.id
      }
      if (this.getActiveQuote.explanation) {
        this.form.explanation = this.getActiveQuote.explanation
      }
    },
    methods: {
      resetErrors: function () {
        this.error = {
          textError: undefined,
          authorError: undefined,
          externalError: undefined
        }
      },
      hideAddQuote: function () {
        this.setChangeQuotes(false)
        this.setChangeQuotes(false)
        this.resetErrors()
      },
      validate: function () {
        let hasErrors = false

        this.resetErrors()
        if (!this.form.quote) {
          this.error.textError = Vue.config.kQuotes.FORM.TEXT_ERROR
          hasErrors = true
        }

        const isExternal = this.form.author === this.external.id

        // Only check external case, in other case, user always select valid a
        // user
        if (isExternal && !this.form.externalAuthor) {
          this.error.externalError = Vue.config.kQuotes.FORM.EXTERNAL_ERROR
          hasErrors = true
        }

        return hasErrors
      },
      saveQuote: function () {
        if (this.validate()) {
          return
        }

        const isExternal =
          this.form.author === this.external.id

        if (isExternal) {
          this.form.author = undefined
        }

        this.mutateQuote(this.form)
        this.hideAddQuote()
      },
      ...mapActions([
        'mutateQuote',
        'setChangeQuotes'
      ])
    },
    computed: {
      ...mapGetters([
        'getAuthors',
        'getActiveQuote'
      ]),
      external: function () {
        return Vue.config.kQuotes.FORM.EXTERNAL_AUTHOR_LIST
      }
    }
  }
</script>

<style lang='css' src='./AddQuotes.css' scoped></style>



// WEBPACK FOOTER //
// AddQuotes.vue?db73d860